import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-1d3c5472.js';
import { r as returnScreenSize } from './screen-89b22340.js';
import { o as observeRootChange } from './utils-1cea37e8.js';

const patternlibLanguagePickerCss = "*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:var(--color-steel-200)}::before,::after{--tw-content:''}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-0.25em}sup{top:-0.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type='search']{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:var(--color-steel-400)}input::placeholder,textarea::placeholder{opacity:1;color:var(--color-steel-400)}button,[role=\"button\"]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}.box-border{box-sizing:border-box}.grid{display:grid}.w-full{width:100%}.py-4{padding-top:var(--spacing-4);padding-bottom:var(--spacing-4)}.px-0{padding-left:var(--spacing-0);padding-right:var(--spacing-0)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}:host{display:inline-block}";

const PatternlibLanguagePicker = class {
  /**
   * Monitoring the options data
   */
  arrayDataWatcher(newValue) {
    if (typeof newValue === 'string') {
      this._optionData = JSON.parse(newValue);
    }
    else {
      this._optionData = newValue;
    }
    this.languages = this._optionData;
    this.stringDataWatcher(this.selected);
  }
  /**
   * Monitoring the selected data
   */
  stringDataWatcher(defaultValue) {
    if (typeof defaultValue === 'string' && defaultValue != '' && this._optionData !== null && this._optionData.length > 0) {
      const defaultSelectedItem = this._optionData.filter(item => item.value === defaultValue);
      this.selectedLanguage = defaultSelectedItem[0];
    }
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.select = createEvent(this, "lhSelect", 7);
    this._optionData = null;
    this.options = undefined;
    this.selected = undefined;
    this.width = '256px';
    this.show = false;
    this.flyoutPosition = 'auto';
    this.isOpen = this.show;
    this.mobile = false;
    this.languages = [];
    this.selectedLanguage = null;
    this.selectItemClick = this.selectItemClick.bind(this);
    this.openFlyoutmenu = this.openFlyoutmenu.bind(this);
    this.onFlyoutClosed = this.onFlyoutClosed.bind(this);
  }
  componentWillLoad() {
    this.arrayDataWatcher(this.options);
    this.stringDataWatcher(this.selected);
    const screen = returnScreenSize();
    if (screen === 'isMobile') {
      this.mobile = true;
    }
  }
  connectedCallback() {
    const target = document.documentElement;
    const attribute = 'breakpoint';
    const options = {
      attributes: true,
    };
    const callback = e => {
      const screen = observeRootChange(attribute, e);
      if (screen !== null) {
        this.mobile = screen === 'isMobile';
      }
    };
    this.observer = new MutationObserver(callback);
    this.observer.observe(target, options);
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  /**
   * Provide a method to monitor if the component gets clicked outside
   */
  handleWindowClick(e) {
    if (this.isOpen) {
      if (e.target != this.hostElement) {
        this.isOpen = false;
      }
    }
  }
  async openFlyoutmenu(e) {
    this.isOpen = !this.isOpen;
    /* IE11 fix without it would also trigger handleWindowClick and set isOpen to false again */
    e.stopPropagation();
    e.preventDefault();
  }
  selectItemClick(item) {
    return (_) => {
      this.stringDataWatcher(item.value);
      this.select.emit({ selected: item.value });
      this.isOpen = false;
    };
  }
  onFlyoutClosed() {
    this.isOpen = false;
  }
  render() {
    var _a, _b, _c;
    const flyoutmenuContentClasses = {
      'grid py-4 px-0 w-full box-border': true,
    };
    return (h(Host, null, h("patternlib-flyoutmenu", { onLhFlyoutClosed: this.onFlyoutClosed, width: this.width, show: this.isOpen, "flyout-position": this.flyoutPosition, "default-align": "auto" }, h("patternlib-textlink", { label: this.mobile ? (_a = this.selectedLanguage) === null || _a === void 0 ? void 0 : _a.value.toUpperCase() : (_b = this.selectedLanguage) === null || _b === void 0 ? void 0 : _b.label, "icon-position": "right", slot: "flyoutmenu-button", onClick: this.openFlyoutmenu, size: "big" }, h("patternlib-icon", { iconName: "globe", size: "40px", slot: "icon" })), h("div", { slot: "flyoutmenu-content", class: flyoutmenuContentClasses }, (_c = this.languages) === null || _c === void 0 ? void 0 : _c.map(item => {
      return h("patternlib-flyoutmenu-item", { label: item.label, detail: item.detail, onClick: this.selectItemClick(item) });
    })))));
  }
  get hostElement() { return getElement(this); }
  static get watchers() { return {
    "options": ["arrayDataWatcher"],
    "selected": ["stringDataWatcher"]
  }; }
};
PatternlibLanguagePicker.style = patternlibLanguagePickerCss;

export { PatternlibLanguagePicker as patternlib_language_picker };
